import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { cx } from '@lib/utils/classNames';

export type BtnKind = 'primary' | 'ghost';

export interface BtnProps {
  children: ReactNode;
  kind?: BtnKind;
  href?: string;
  icon?: string;
  /** Open in a new tab. If unset, auto-detects external URLs. */
  target?: '_blank' | '_self';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
}

function isExternal(href: string): boolean {
  return /^https?:\/\//i.test(href) && !href.includes('alisonhaire.com');
}

export function Btn({ children, kind = 'primary', href = '#', icon, target, onClick, className }: BtnProps) {
  const external = isExternal(href);
  const finalTarget = target ?? (external ? '_blank' : undefined);
  const rel = finalTarget === '_blank' ? 'noreferrer noopener' : undefined;

  return (
    <a
      className={cx(`aw-btn aw-btn--${kind}`, className)}
      href={href}
      target={finalTarget}
      rel={rel}
      onClick={onClick}
    >
      {children}
      {icon && <Icon name={icon} size={16} />}
    </a>
  );
}
